import React, { useState } from "react";
import styled from "styled-components";

const initialUserList = [
  {
    id: 1,
    name: "New Friend1",
    userSrc:
      "https://dongsooo.github.io/imgs/dongstgram_img/05_recommend_user_img1.jpg",
    isFollow: false,
  },
  {
    id: 2,
    name: "New Friend2",
    userSrc:
      "https://dongsooo.github.io/imgs/dongstgram_img/05_recommend_user_img2.jpg",
    isFollow: false,
  },
  {
    id: 3,
    name: "New Friend3",
    userSrc:
      "https://dongsooo.github.io/imgs/dongstgram_img/05_recommend_user_img3.jpg",
    isFollow: false,
  },
];

const RecommendFriend = () => {
  const [userList, setUserList] = useState(initialUserList);

  const followClicked = (id) => {
    setUserList((prevList) =>
      prevList.map((user) =>
        user.id === id ? { ...user, isFollow: !user.isFollow } : user
      )
    );
  };

  return (
    <RecommendFriendWrap>
      <RecommendFriendContentBox>
        <p className="recommendTitle">회원님을 위한 추천</p>
        {userList.map((user) => {
          return (
            <div className="recommendList" key={user.id}>
              <img src={user.userSrc} alt="" />
              <div className="nameBox">
                <p>{user.name}</p>
                <p>회원님을 위한 추천</p>
              </div>
              <div className="followCommetBox">
                {user.isFollow ? (
                  <p
                    onClick={() => followClicked(user.id)}
                    style={{ color: "#d54646" }}
                  >
                    언팔로우
                  </p>
                ) : (
                  <p
                    onClick={() => followClicked(user.id)}
                    style={{ color: "#0095f6" }}
                  >
                    팔로우
                  </p>
                )}
              </div>
            </div>
          );
        })}
      </RecommendFriendContentBox>
    </RecommendFriendWrap>
  );
};

export default RecommendFriend;

const RecommendFriendWrap = styled.div`
  width: 40%;

  @media (max-width: 1264px) {
    display: none;
  }
`;

const RecommendFriendContentBox = styled.div`
  margin-top: 100px;
  width: 100%;
  height: 520px;

  .recommendTitle {
    color: #2f2f2f;
    padding: 30px;
    padding-bottom: 0;
    font-weight: bold;
  }

  .recommendList {
    display: flex;
    padding: 10px 30px;

    img {
      width: 46px;
      height: 46px;
      border-radius: 50%;
    }

    .nameBox {
      margin-left: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      flex: 1;

      p {
        margin-bottom: 0;
      }

      p:last-child {
        font-size: 0.7em;
      }
    }
    .followCommetBox {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 50px;

      p {
        margin-bottom: 0;
        cursor: pointer;
        font-size: 0.8em;
      }
    }
  }
`;
